import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FinanceReportsModel } from '@shared/data-access/models';
import { filter, Observable, take } from 'rxjs';
import { FinanceReportsAction } from '../actions';
import { FinanceReportsReducer } from '../reducers';
import { FinanceReportsSelector } from '../selectors';

@Injectable()
export class FinanceReportsFacade {
  selectedItem$ = this._store.select(FinanceReportsSelector.selectFinanceReports);
  constructor(private _store: Store<FinanceReportsReducer.FinanceReportsState>) {}

  /**
   * Get @FinanceReportsModel by id
   */
  getById(id: number): Observable<FinanceReportsModel | null> {
    this._store.dispatch(FinanceReportsAction.loadItem({ id }));
    return this.selectedItem$.pipe(
      filter(val => !!val && val.id === id),
      take(1)
    ) as Observable<FinanceReportsModel | null>;
  }
}
